import * as React from "react";
import { useState, useEffect } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import { FxEnergyDetailPopup } from "./FxEnergyDetailPopup";

export const FxIconValuePanelNoChart = (props) => {
  const { energy, inloList, allValues } = props;
  const [icon, setIcon] = React.useState("steam_icon001.png");
  const [nowTot, setNowTot] = useState("");
  const [sumTot, setSumTot] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const getIcon = (x) => {
    let icon = "steam_icon001.png";
    if (x === "AIR") {
      icon = "air_icon001.png";
    } else if (x === "water") {
      icon = "water_icon001.png";
    } else if (x === "steam") {
      icon = "steam_icon001.png";
    } else if(x === "ELEC"){
      icon = 'elec_icon001.png'
    } else if(x === "EPWR"){
      icon = 'epwr_icon001.png'
    }
    return icon;
  };

  useEffect(() => {
    setIcon(getIcon(energy.engId));
  }, []);

  useEffect(() => {
    const values = allValues ? allValues[energy.engId] : undefined;
    let tmpNowTot = 0;
    let tmpSumTot = 0;

    if (values === undefined) {
      return;
    }

    for (const inlo of inloList) {
      if (values && values[inlo.inloNo]) {
        tmpNowTot += values[inlo.inloNo].now;
        tmpSumTot += values[inlo.inloNo].sum;
      }
    }

    setNowTot(tmpNowTot);
    setSumTot(tmpSumTot);
  }, [allValues, energy.engId]);

  return (
    <StyledEngineProvider injectFirst>
      <div className="dashUnit">
        <div className="unitBox">
          <img src={icon} />
          <span className="FxIconValueName" onClick={openModal}>
            {energy.engName}
          </span>
          <div className="FxIconValueBox">
            <span className="FxIconValueText">적산</span>
            <span className="FxIconValueValue">{sumTot.toLocaleString()}</span>
            <span className="FxIconValueUnit">{energy.engUnit}</span>
          </div>
          <div className="FxIconValueBox">
            <span className="FxIconValueText">순시</span>
            <span className="FxIconValueValue">{nowTot.toLocaleString()}</span>
            <span className="FxIconValueUnit">{energy.engUnit}</span>
          </div>
        </div>
      </div>
      <FxEnergyDetailPopup open={modalOpen} close={closeModal} data={props} />
    </StyledEngineProvider>
  );
};
